<template>
    <div class="bizcomp-assets box">
        <el-tabs v-model="activeType" class="tab">
            <el-tab-pane v-if="$util.checkModuleid(100001001)" name="assets" label="资产总览">
                <my-assets ref="assets"></my-assets>
            </el-tab-pane>
            <el-tab-pane
                v-if="$util.checkModuleid(100001002) && myPhaseDisplay"
                name="phase"
                label="盈亏查询"
            >
                <my-phase ref="phase"></my-phase>
            </el-tab-pane>
            <!-- <el-tab-pane name="combination" label="组合投资">
                <combo-assets ref="comboAssets"></combo-assets>
            </el-tab-pane> -->
            <el-tab-pane
                v-if="$util.checkModuleid(100001003) && $util.getConfig().hideFunc"
                name="collection"
                label="我的自选"
            >
                <my-collection ref="collection"></my-collection>
            </el-tab-pane>
        </el-tabs>
        <a
            v-if="
                $cache.getBinded() &&
                activeType == 'assets' &&
                $util.getConfig().hideFunc &&
                $const.tracesLogDisplay
            "
            class="file-button second-button"
            :href="downLoadUrl"
            download="资产证明"
            target="_blank"
            v-on:click="tracesLog"
        >
            下载资产证明
        </a>
        <el-dialog
            title="密码过期提示"
            :visible.sync="resetVisible"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            class="prop"
            width="420px"
        >
            <div class="info-box">
                <el-alert
                    :title="
                        '您的' +
                        (userOtherInfo.specialflag == 1
                            ? '交易'
                            : userOtherInfo.specialflag == 2
                            ? '登录'
                            : userOtherInfo.specialflag == 3
                            ? '登录密码和交易'
                            : '') +
                        '密码已过期，请立即修改！'
                    "
                    type="warning"
                    show-icon
                    :closable="false"
                />
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click.once="forgetPwd">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import myAssets from "@/components/fund/myAssets";
import myCollection from "@/components/fund/myCollection";
import myPhase from "@/components/fund/myPhase";
import commonApi from "@/api/common";
import urls from "@/api/urls";

export default {
    name: "AssetTotal",
    components: {
        myAssets,
        myCollection,
        myPhase
    },
    mixins: [mixin],
    data() {
        return {
            activeType: "assets", // tab类型
            downLoadUrl: "", // 下载资产证明url
            resetVisible: false,
            loginPwdType: "0",
            userOtherInfo: { specialflag: 0 },
            myPhaseDisplay: false // 控制盈亏查询入口是否显示
        };
    },
    watch: {
        activeType(val) {
            if (val == "assets") {
                this.$refs.assets.searchAssets();
            } else if (val == "combination") {
                this.$refs.comboAssets.getAssets();
            } else if (val == "collection") {
                this.$refs.collection.searchFund();
            }
        }
    },
    async created() {
        if (this.$route.query && this.$route.query.tab) {
            this.activeType = this.$route.query.tab;
            this.$router.replace({ path: this.$route.path, query: {} });
        }
        this.downLoadUrl =
            this.$util.fileUploadPath(urls.assetsPdf) + "?token=" + this.$cache.getSessionToken();

        this.userOtherInfo = this.$cache.getUserOtherInfo();
        if (!this.$util.getConfig().hideFunc) return;
        // 1：需要强制修改交易密码，3：需要强制修改交易密码和登录密码
        if (this.userOtherInfo.specialflag == "1" || this.userOtherInfo.specialflag == "3") {
            this.resetVisible = true;
            this.loginPwdType = 0;
        }
        // 2：需要强制修改登录密码;
        if (this.userOtherInfo.specialflag == "2") {
            this.resetVisible = true;
            this.loginPwdType = 1;
        }
    },
    mounted() {
        // this.myPhaseDisplay =
        //     this.$cache.getParamValue("business_module") &&
        //     this.$cache.getParamValue("business_module").bizenable["027"];
    },
    methods: {
        /* 跳转到忘记密码页面 */
        forgetPwd() {
            if (this.loginPwdType == 0) {
                this.$router.push({ name: "changetpwd" });
            } else {
                this.$router.push({ name: "changelpwd" });
            }
        },
        tracesLog() {
            commonApi.commonLeaveTracesLog(this, {
                eventid: this.$const.RECORD.acct_download_file,
                eventname: `下载文件`,
                content: JSON.stringify({ name: "资产证明", url: this.downLoadUrl })
            });
        }
    }
};
</script>

<style lang="scss">
@import "../../assets/css/varibles";
.box {
    background: var(--color-bg-page);
    border: 1px solid var(--color-divided);
    position: relative;
    margin-bottom: 20px;
    .tab {
        margin: 0 25px;
        .el-tabs__nav-wrap:after {
            background: var(--color-divided);
        }
        .el-tabs__nav-scroll {
            line-height: 70px;
            .el-tabs__active-bar {
                bottom: 5px;
                height: 3px;
                background: var(--color-primary);
            }
            .el-tabs__item {
                font-size: $f20;
                font-weight: 400;
            }
            .el-tabs__item.is-active {
                font-weight: 500;
            }
        }
        .el-tabs__content {
            padding: 0 0 20px;
            .fund-offset .cell {
                padding: 0 10px 0 20px;
            }
            .fund-arr {
                padding: 0 20px;
                .cell {
                    padding: 0;
                }
            }
        }
    }
    .file-button {
        position: absolute;
        width: 100px;
        height: 40px;
        top: 15px;
        right: 25px;
        //background: var(--button-second-bg);
        //color: var(--color-text-regular);
        text-align: center;
        border-radius: 2px;
        font-size: 14px;
        line-height: 40px;
        cursor: pointer;
    }
}
</style>
